export default __webpack_public_path__ + "static/media/fix.12a2c5bf.svg";